/* eslint-disable import/no-unresolved */
import React, { useEffect } from 'react';

import * as getStatic from '@backpackjs/core-nextjs/get-static';
import { store } from '@backpackjs/storefront';

import BlogTemplate from '../../../templates/blog';
import { PageErrorBoundary, PageHead } from '../../../_components';

export const getStaticPaths = getStatic.paths.blog;
export const getStaticProps = getStatic.props.blog;

export default function Blog({ isPreview, renderSections, ...props }) {
  const { blog } = props;

  const setBlog = store.recoil.useRecoilState(store.state.blog)[1];

  useEffect(() => {
    setBlog(blog);
  }, [blog?.handle]);

  return (
    <PageErrorBoundary>
      <PageHead page={blog}>
        <BlogTemplate {...props} renderSections={renderSections} />
      </PageHead>
    </PageErrorBoundary>
  );
}
